import { jsx } from '@emotion/react';
import { buildResetStyles, isHtmlNode, isSvgNode } from './buildResetStyles';
const isComponent = (type) => {
    var _a;
    return (typeof type === 'function' ||
        !!((_a = type === null || type === void 0 ? void 0 : type.$$typeof) === null || _a === void 0 ? void 0 : _a.toString().includes('forward')));
};
const componentSelector = '&' + '[class]'.repeat(5);
const isolateCss = (nodeType, styles) => {
    return {
        [componentSelector]: [
            !isComponent(nodeType) && buildResetStyles(nodeType),
            styles.map((stylesItem) => ({
                '&': stylesItem,
            })),
        ],
    };
};
const flatten = (arr) => {
    return arr.reduce((acc, item) => {
        return acc.concat(Array.isArray(item) ? flatten(item) : item);
    }, []);
};
export const isolateComponent = (type, props, ...children) => {
    props = props || {};
    if (!type || isSvgNode(type)) {
        return jsx(type, props, ...children);
    }
    if (props.css || isHtmlNode(type)) {
        props.css = isolateCss(type, flatten([props.css]).filter(Boolean));
    }
    return jsx(type, props, ...children);
};
//# sourceMappingURL=isolateComponent.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)
